const tr = {
  meta: {
    home: {
      title: 'Manifestify | Manifestasyon ve Günlük Olumlama Uygulaması',
      description:
        'Manifestify, iOS ve Android için manifestasyon ve günlük olumlama uygulaması. Kişisel manifestonu oluştur, niyet belirle, vizyon panosu hazırla ve rüyalarını yapay zekâyla çöz.',
    },
    blog: {
      title: 'Manifestasyon Blogu: Olumlamalar, Rehberler ve Metotlar',
      description:
        'Nasıl manifest edilir üzerine uzman rehberler: günlük olumlamalar, 369 metodu, vizyon panoları, scripting ve rüya yorumu. Manifestify ekibinden yeni yazılar.',
    },
    notFound: {
      title: 'Sayfa Bulunamadı | Manifestify',
      description: 'Aradığın sayfa mevcut değil.',
    },
    terms: {
      title: 'Şartlar ve Koşullar | Manifestify',
      description: 'Manifestify uygulamasını ve web sitesini kullanmaya ilişkin şartlar ve koşullar.',
    },
    privacy: {
      title: 'Gizlilik Politikası | Manifestify',
      description: 'Manifestify kişisel verilerini nasıl topluyor, kullanıyor ve koruyor.',
    },
  },

  nav: {
    brandAria: 'Manifestify ana sayfa',
    mainAria: 'Ana menü',
    blog: 'Blog',
    getApp: 'Uygulamayı al',
    languageAria: 'Dili değiştir',
    languageLabel: 'Dil',
  },

  store: {
    downloadOn: 'İndir',
    appStore: 'App Store',
    getItOn: 'İNDİR',
    googlePlay: 'Google Play',
    appleAria: "Manifestify'ı App Store'dan indir",
    googleAria: "Manifestify'ı Google Play'den al",
  },

  home: {
    hero: {
      titleLine1: 'Hayallerini her gün manifest et.',
      titleAccent: 'Manifestify ile!',
      subtitle:
        'Pratiğini canlı tutan manifestasyon uygulaması: günlük olumlamalar, kişisel manifesto, vizyon panoları, niyetler ve yapay zekâ destekli rüya yorumu — hepsi tek yerde. Tekrarla. İnan. Gerçekleştir.',
      note: 'İndirmesi ücretsiz · iOS ve Android',
    },
    features: {
      titlePre: 'Manifest etmek için ihtiyacın olan ',
      titleAccent: 'her şey',
      titlePost: '',
      subtitle:
        'Sabahki ilk olumlamandan dün gecenin rüyasını çözmeye kadar tüm pratiğin için tek uygulama.',
      items: [
        {
          title: 'Günlük Olumlamalar',
          text: 'Aşk, para, sağlık, özgüven ve iç huzur için özenle hazırlanmış yüzlerce olumlama her gün sana ulaşsın.',
        },
        {
          title: 'Kişisel Manifesto',
          text: 'Hedeflerini her gün okuyup pekiştirdiğin kişisel bir manifestoya dönüştür; hayallerin hep gözünün önünde kalsın.',
        },
        {
          title: 'Niyet Belirleme',
          text: 'Net günlük niyetler belirle; uygulama seni gerçekten önem verdiğin şeye bağlı tutsun.',
        },
        {
          title: 'Vizyon Panosu',
          text: 'Yarattığın hayatın dijital vizyon panosunu oluştur, istediğin yerde istediğin zaman görselleştir.',
        },
        {
          title: 'Yapay Zekâ Rüya Yorumu',
          text: 'Rüyanı anlat, yapay zekâ destekli derinlikli yorumlarla gizli mesajlarını keşfet.',
        },
        {
          title: 'Enerji Kartları',
          text: 'Her gün bir enerji kartı çek; kısa bir farkındalık anı ve taze bir ilham dozu.',
        },
        {
          title: 'Günlük Hatırlatıcılar',
          text: 'Seçtiğin saatlerde nazik bildirimler; pratiğin artık hafızana ya da motivasyonuna bağlı kalmasın.',
        },
        {
          title: 'Temalar ve Duvar Kâğıtları',
          text: 'Pratiğini kişisel ve ilham verici kılan zarif temalar ve duvar kâğıtları.',
        },
      ],
    },
    how: {
      titlePre: 'Nasıl ',
      titleAccent: 'çalışır',
      titlePost: '?',
      steps: [
        {
          title: 'Niyetini belirle',
          text: 'Neyi manifest etmek istediğini seç ve yüzlerce özenli olumlamadan kendi manifestonu oluştur.',
        },
        {
          title: 'Her gün pratik yap',
          text: 'Olumlamalarını tekrarla, vizyon panonu görselleştir, enerji kartını çek. Hatırlatıcılar serini canlı tutar.',
        },
        {
          title: 'İnan ve gerçekleştir',
          text: 'Pratiğin gün geçtikçe biriktikçe odağının, özgüveninin ve seçimlerinin nasıl değiştiğini gör.',
        },
      ],
    },
    blogTeaser: {
      titlePre: '',
      titleAccent: 'Manifestasyon',
      titlePost: ' sanatını öğren',
      subtitle: 'Manifestify ekibinden, gerçek günlük pratik için yazılmış rehberler ve teknikler.',
      viewAll: 'Tüm yazıları gör →',
    },
    faq: {
      titlePre: 'Sıkça sorulan ',
      titleAccent: 'sorular',
      titlePost: '',
      items: [
        {
          q: 'Manifestify nedir?',
          a: "Manifestify, iOS ve Android için bir manifestasyon ve günlük olumlama uygulamasıdır. Tüm pratiğini bir araya getirir: aşk, kariyer, bolluk ve özgüven gibi kategorilerde olumlamalar, kişisel manifesto, niyet belirleme, vizyon panosu, günlük hatırlatıcılar, enerji kartları ve yapay zekâ destekli rüya yorumu.",
        },
        {
          q: 'Manifestify ücretsiz mi?',
          a: "Evet. Manifestify hem App Store'da hem Google Play'de ücretsiz indirilir ve kullanılır. İsteğe bağlı premium planlar, olumlama kütüphanesinin tamamını ve sınırsız yapay zekâ rüya yorumu gibi gelişmiş özellikleri açar.",
        },
        {
          q: 'Manifestasyon nedir?',
          a: 'Manifestasyon; hedeflerini odaklanmış dikkat, olumlu inanç ve istikrarlı eylemle gerçeğe dönüştürme pratiğidir. Teknikleri arasında günlük olumlamalar, görselleştirme, vizyon panoları, scripting ve 369 metodu bulunur.',
        },
        {
          q: 'Günlük olumlamalar nasıl çalışır?',
          a: "Olumlamalar, her gün tekrarladığın kısa ve şimdiki zamanda kurulmuş olumlu cümlelerdir. Haftalar içinde iç konuşmanı yeniden şekillendirir ve dikkatini hedeflerinle uyumlu fırsatlara yönlendirir. Anahtar istikrardır; Manifestify'ın günlük hatırlatıcılar sunmasının sebebi de budur.",
        },
        {
          q: "Manifestify iPhone ve Android'de var mı?",
          a: "Evet. Manifestify, App Store'da iPhone ve iPad için, Google Play'de ise Android cihazlar için mevcuttur.",
        },
        {
          q: 'Yapay zekâ rüya yorumu özelliği nasıl çalışır?',
          a: 'Rüyanı uygulamada anlatırsın; Manifestify sembollerini, duygularını ve temalarını analiz ederek anında, derinlikli bir yorum sunar. Bu yorumu kendi bağlamınla daha da detaylandırabilirsin.',
        },
      ],
    },
    download: {
      title: 'Bugün manifest etmeye başla',
      text: "Her sabaha niyetle başlayanlara katıl. Manifestify'ı ücretsiz indir ve kalıcı bir pratik kur.",
    },
  },

  blog: {
    titlePre: 'Manifestify ',
    titleAccent: 'Blog',
    titlePost: '',
    subtitle:
      'Manifestasyon, olumlamalar, görselleştirme ve rüya yorumu üzerine pratik rehberler. İşe yarayan bir günlük pratik kurmak için ihtiyacın olan her şey.',
    schemaName: 'Manifestify Blog',
    schemaDescription:
      'Manifestasyon, günlük olumlamalar, vizyon panoları, scripting ve rüya yorumu üzerine rehberler.',
    readTime: '{n} dk okuma',
  },

  post: {
    breadcrumbAria: 'Sayfa yolu',
    home: 'Ana Sayfa',
    blog: 'Blog',
    ctaTitle: 'Manifestify ile pratiğe dök',
    ctaText:
      'Günlük olumlamalar, kişisel manifesto, vizyon panoları, niyetler ve yapay zekâ rüya yorumu. Tüm manifestasyon pratiğin, tek bir ücretsiz uygulamada.',
    faqTitle: 'Sıkça sorulan sorular',
    relatedTitle: 'Okumaya devam et',
    relatedAria: 'İlgili yazılar',
  },

  notFound: {
    text: 'Bu sayfa yok ama hayallerin hâlâ var.',
    backHome: 'Ana sayfaya dön',
    readBlog: 'Blogu oku',
  },

  footer: {
    tagline:
      'Hayallerini her gün manifest et. Olumlamalar, niyetler, vizyon panoları ve rüya yorumu tek uygulamada.',
    exploreTitle: 'Keşfet',
    exploreAria: 'Keşfet',
    home: 'Ana Sayfa',
    blog: 'Blog',
    downloadTitle: 'Uygulamayı indir',
    downloadAria: 'İndir',
    appStoreLink: 'iPhone ve iPad (App Store)',
    playStoreLink: 'Android (Google Play)',
    legalTitle: 'Yasal',
    legalAria: 'Yasal',
    terms: 'Şartlar ve Koşullar',
    privacy: 'Gizlilik Politikası',
    copyright: '© {year} Manifestify — Portal Studio. Tüm hakları saklıdır.',
  },

  legal: {
    back: 'Geri',
    translationNotice:
      'Bu çeviri yalnızca kolaylık sağlamak amacıyla sunulmaktadır. Belgenin yasal olarak bağlayıcı sürümü İngilizce olanıdır.',
    lastUpdated: 'Son güncelleme: {date}',
  },
};

export default tr;
